import script from "./ShopCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopCategory.vue?vue&type=script&setup=true&lang=js"

import "./ShopCategory.vue?vue&type=style&index=0&id=e132cfc6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e132cfc6"]])

export default __exports__